import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Http, Auth, Event } from '.';
import { Alert } from 'react-bootstrap';

class HttpErrorMonitor extends Component {

  state = {
    validating: false,
    redirect: false
  }

  componentDidMount() {
    Event.on('http.error', this.listenForHttpErrors.bind(this));
  }

  componentWillUnmount() {
    Event.off('http.error', this.listenForHttpErrors.bind(this));
  }

  listenForHttpErrors(error) {
    const statusCode = !!error.status ? error.status : null;

    if (!!error.config && error.config.url !== 'auth/me/validate' && (statusCode === 403 || statusCode === 401)) {
      this.setState({
        validating: true
      });

      window.ToastManager.show({
        variant: 'warning',
        title: 'Validación',
        message: 'Por tu seguridad estamos validando tu sesión.'
      });

      Http.post('auth/me/validate').then((response) => {

      }, (error) => {
        Auth.logout();

        this.setState({
          redirect: true
        });
      }).finally(() => {
        this.setState({
          validating: false
        });
      })
    }
  }

  render() {
    const { validating, redirect } = this.state;

    if (!validating) {
      return null;
    }

    if (redirect) {
      return <Redirect to="/auth/login" />
    }

    return (
      <Alert variant="warning">
        Por tu seguridad estamos validando tu sesión.
      </Alert>
    )
  }
}

export default HttpErrorMonitor;